export enum AnnouncementsListColumns {
  'ID' = 'ID',
  'CREATED_DATE' = 'Created Date',
  'NAME' = 'Name',
  'TITLE' = 'Title'
}

export const ANNOUNCEMENTS_SEARCH_KEYS = {
  SEARCH: 'searchText',
  CREATED_AT_DATE: 'createdAtDateRange'
}

export const ANNOUNCEMENT_MORE_MENU_ITEMS = ['Update Status', 'Duplicate']

export const ANNOUNCEMENT_STEP_TITLES = {
  STEPS: 'Total Steps',
  STEP: 'Step',
  LABEL: 'Label',
  IMAGE: 'Image',
  TITLE: 'Title',
  DESCRIPTION: 'Description',
  CTA_LABEL: 'CTA Label',
  CTA_LINK: 'CTA Link',
  CTA: 'CTA',
  NONE: ''
}

export const ANNOUNCEMENT_TABS_INDEX = {
  SETTINGS: 0,
  TRANSLATIONS: 1
}

export const ANNOUNCEMENT_DETAILS_TABS = ['Settings', 'Translations']

export const ANNOUNCEMENT_ICON_DIMENSION = {
  HEIGHT: 100,
  WIDTH: 100
}

export const UPDATE = 'Update Status'
export const ANNOUNCEMENT = 'Announcement'

export const ROW_STYLE = 'flex flex-row justify-between p-3 mt-5'
export const COL_STYLE = 'flex flex-col w-3/5 space-y-3'
export const STEP_STYLE =
  'flex flex-row justify-between p-3 mt-5 border border-[#B9B9B9] rounded-md'

export const CREATE_OR_UPDATE_ANNOUNCEMENT_TITLES = {
  GENERAL_INFOMATION: 'General Information',
  NAME: 'Name'
}

export const ANNOUNCEMENT_KEY = {
  ANNOUNCEMENT_ID: 'NewFeatureID',
  NAME: 'NewFeatureName',
  LABEL: 'NewFeatureLabel',
  IMAGE_FILE: 'imageFile',
  IMAGE_ID: 'NewFeatureImageID',
  TITLE: 'NewFeatureTitle',
  DESCRIPTION: 'NewFeatureDescription',
  CTA_LABEL: 'NewFeatureButtonLabel',
  CTA_LINK: 'NewFeatureButtonLink',
  STEP: 'Step',
  IMAGE_URL: 'NewFeatureImageUrl'
}

export const INCREMENT_COUNTER = 1

export const STEPS_NUM_LIMIT = 10

export const UPDATE_BTN_LABEL = 'Update'
export const CANCEL_BTN_LABEL = 'Cancel'

export const ANNOUNCEMENT_TRANSLATIONS_COLUMN_NAME: AnnouncementTranslationsFields =
  {
    NewFeatureLabel: 'Label',
    NewFeatureTitle: 'Title',
    NewFeatureDescription: 'Description',
    NewFeatureButtonLabel: 'CTA Label'
  }
export const ANNOUNCEMENT_ID_KEY_NAME = 'NewFeatureID'

export const ANNOUNCEMENT_TRANSLATIONS_KEYS = [
  'NewFeatureLabel',
  'NewFeatureTitle',
  'NewFeatureDescription',
  'NewFeatureButtonLabel'
]

export const PREVIEW_SWIPER_DEFAULT_INDEX = 0
export const ANNOUNCEMENT_PREVIEW_IMAGE = {
  WIDTH: 233,
  HEIGHT: 140
}
